import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Modal } from '~/components/modal/modal-old.js';
import Icon from '~/components/icon/icon.js';
import { ICON_ARROW_BACK } from '~/components/icon/index.js';

import RichTextRenderer from '../rich-text-renderer';

import { updateMyNotificationsPopupAdditionalData } from '../ducks/my-notifications.js';

const ModalWrapper = styled.div`
	position: absolute;
	left: ${props => (props.small ? '5%' : props.isNowbetnow ? 'calc(50% - 200px)' : '25%')};
	right: ${props => (props.small ? '5%' : '25%')};
	top: 10%;
	border-radius: 3px;
	background-color: rgba(var(--notification-popup-bg), 1);
	max-width: ${props => (props.isNowbetnow ? '400px' : 'auto')};
	margin-bottom:;
`;

// const TitleWrapper = styled.div`
// 	font: var(--h2);
// 	padding: 3% 13.5% 6px 13.5%;
// 	text-align: center;
// 	color: rgba(var(--notification-popup-title), 1);
// `;

// const SubTitleWrapper = styled.div`
// 	font: var(--caption);
// 	font-size: 15px;
// 	line-height: 20px;
// 	padding: 0px 13.5% 3% 13.5%;
// 	color: rgba(var(--base-06), 1);
// 	text-align: center;
// 	color: rgba(var(--notification-popup-subtitle), 1);
// 	max-height: 400px;
// 	overflow-y: scroll;
// 	-webkit-overflow-scrolling: touch;

// 	&::-webkit-scrollbar {
// 		display: none;
// 	}
// `;

const ButtonWrapper = styled.div`
	padding: ${props => (props.small ? '24px' : '24px 70px')};
	display: flex;
	justify-content: center;
`;

const Button = styled.button`
	background-color: rgba(var(--notification-popup-button-bg), 1);
	color: rgba(var(--notification-popup-button-text), 1);
	border-radius: var(--brand-border-radius, 3px);
	display: inline-block;
	font: var(--h3);
	text-align: center;
	white-space: break-spaces;
	word-break: break-word;
	padding: 14px 25%;
	border-radius: 26px;
`;

const Header = styled.div`
	width: 100%;
`;

const CloseWrapper = styled.button`
	margin: 10px 15px;
	color: rgba(var(--notification-popup-close-icon), 1);
`;

const MyNotificationAdditionalDataPopup = () => {
	const dispatch = useDispatch();

	const popupAdditionalData = useSelector(state => state.myNotifications.popupAdditionalData);
	if (popupAdditionalData) {
		const { title, subtitle, ctaText, ctaCallback, onCloseClick, isMobileDevice } = popupAdditionalData;
		return (
			<Modal show={!!popupAdditionalData} blurBg>
				<ModalWrapper small={isMobileDevice}>
					<Header>
						<CloseWrapper onClick={onCloseClick}>
							<Icon type={ICON_ARROW_BACK} className="my-notification-popup-back-button" />
						</CloseWrapper>
					</Header>
					{/* Title */}
					{title && (
						<RichTextRenderer
							data={title}
							key="title"
							additionalClassName="my-notification-popup-additional-data-title"
							additionalClassNameEditor="my-notification-popup-additional-data-title_editor"
						/>
					)}
					{/* Subtitle */}
					{subtitle && (
						<RichTextRenderer
							data={subtitle}
							key="subtitle"
							additionalClassName="my-notification-popup-additional-data-subtitle"
							additionalClassNameEditor="my-notification-popup-additional-data-subtitle_editor"
						/>
					)}
					{ctaText && (
						<ButtonWrapper small>
							<Button
								onClick={() => {
									dispatch(updateMyNotificationsPopupAdditionalData(null));
									ctaCallback();
								}}
							>
								{ctaText}
							</Button>
						</ButtonWrapper>
					)}
				</ModalWrapper>
			</Modal>
		);
	}
	return null;
};

export default MyNotificationAdditionalDataPopup;
